import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Affix, Grid, Drawer } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import TrainingMarquee from "../components/TrainingAnnouncement/TrainingMarquee";

const { Header: AntHeader, Content, Sider } = Layout;

const { useBreakpoint } = Grid;

interface MainProps {
  children: JSX.Element;
  namePage?: string;
  subNamePage?: string;
  showHeader?: boolean;
}

const Main: FC<MainProps> = ({ children, namePage }) => {
  const screens = useBreakpoint();


  const sidenavColor = "#1890ff";
  const sidenavType = "#fff";
  const fixed = false;

 // const { footerShow, showSidenav } = useAppSelector((state) => state.layout);

  const [open, setOpen] = useState(false);



  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");


  const openDrawer = () => setOpen(!open);

  useEffect(() => {
    if(screens.md){
      setOpen(false)
    }
  }, [ screens ]);

  return (
    <Layout
      className={`layout-dashboard ${
        pathname === "profile" ? "layout-profile" : ""
      } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
      hasSider
    >
      <Drawer
        title={false}
        placement="left"
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        key="left"
        width={250}
      >
        <Layout
          className={`layout-dashboard layout-dashboard-rtl}`}
        >
          <Sider
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${
              sidenavType === "#fff" ? "active-route" : ""
            }`}
            style={{ background: sidenavType }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
        </Layout>
      </Drawer>

      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
        width={250}
        theme="light"
        className={`sider-primary ant-layout-sider-primary ${
          sidenavType === "#fff" ? "active-route" : ""
        }`}
        style={{ background: sidenavType, borderRadius: "12px 12px 0px 0px" }}
      >
        <Sidenav color={sidenavColor} />
      </Sider>

      <Layout>
        <AntHeader>
          <Header name={namePage}  onPress={openDrawer} />
        </AntHeader>

        {/*
          ป้ายเชิญเข้าร่วมอบรม — วางถัดจากเมนูลงมา เหนือเนื้อหา
          component คืน null เองเมื่อ: ไม่ใช่ role factory / ไม่มีอบรมที่ยังจองได้
          / ผู้ใช้กดปิดไปแล้ว → ไม่กินพื้นที่เมื่อไม่มีอะไรจะประกาศ
        */}
      <TrainingMarquee />

        <Content className="content-ant">{children}</Content>
      </Layout>
    </Layout>
  );
};

export default Main;
